import { render, staticRenderFns } from "./MyLeaveComponent.vue?vue&type=template&id=7844802d&"
import script from "./MyLeaveComponent.vue?vue&type=script&lang=js&"
export * from "./MyLeaveComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports